// extracted by mini-css-extract-plugin
export default {"back":"Back2Packs_back__4bv7c","image":"Back2Packs_image__CWlQp","backText":"Back2Packs_backText__joUeL"};